import React from 'react'
import Layout from '../layout/Layout'
import { observer } from "mobx-react-lite"
import classes from './styles.module.scss'
// import Button from '@mui/material/Button'
// import { useNavigate } from "@reach/router"

const Google = observer(() => {
  // const navigate = useNavigate();

  return <Layout className={classes.policies}>
    <head>
    <link rel='shortcut icon' href='https://sessionloops-usa.oss-us-west-1.aliyuncs.com/icons/logo512.png'/>
    </head>
    <div className={classes['container']}>
        <div className={classes['head1']}>
            <h1>Session Loops Google OAuth2 Homepage</h1>
        </div>

        <div className={classes['head2']}>
            <h2>About</h2>
        </div>

        <div className={classes['paragraph']}>
            <p>You have to sign in to view our content. When you sign in, google will share your name, email and profile picture with us. We won't share this data with any others. We only send emails to you when neccessary. For example, if you request a password reset or email address reset, or you write to us to seek support. <a href='mailto:support@sessionloops.com'>Email us</a>> if you have any questions. </p>
        </div>

        <div className={classes['head2']}>
            <h2>Google OAuth2 Homepage</h2>
        </div>

        <div className={classes['paragraph']}>

            <ul>
                <li>Accurately represents your app's identity: the Session Loops App is <a href='https://sessionloops.com'>sessionloops.com</a> which is a next generation music production platform/service, where you can create your customized loops based on grooves, licks, chord progressions, FX, registers and more. All loops you downloaded from Session Loops are royalty-free You can get infinite production quality loops to get inspired or finish your project.</li>
                <li>What will this app do with user data? The only user data received is: name, email and profile picture. These will be saved and re-displayed to the user. The email will be used to reply to messages sent by the user. The email will be used to identify the user. Some users will be granted access to additional content.</li>
                <li>How does this app enhance user functionality? Our service and content is only displayed to signed in users.</li>
                <li>Link to Privacy Policy:<a href='https://sessionloops.com/policies/privacy-policy'>Privacy Policy</a></li>
                <li>Describe the content, context, or connection to the app: The sessionloops App is this website, which is a online music service providing and selling editable and downloadable audio samples.</li>
            </ul>
        </div>

        <div className={classes['head2']}>
            <h2>Google OAuth2 Limited Use Disclosure</h2>
        </div>
        
        <div className={classes['paragraph']}>
            <p>This app doesn't request restricted scopes, but if it did, the  holtstrom.com App's use of information received from Google APIs will adhere to the <a href='https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes'>Google API Services User Data Policy</a>, including the Limited Use requirements.</p>
        </div>

        <div className={classes['head2']}>
            <h2>Cookies</h2>
        </div>

        <div className={classes['paragraph']}>
            <p>Cookies are short messages sent from your browser to websites you visit. This site uses cookies. By using this site you consent to the use of cookies.This site uses cookies to identify who is logged in, and google analytics uses cookies to record anonymized browsing behaviour.</p>
        </div>

        <div className={classes['head2']}>
            <h2>Terms of Service</h2>
        </div>

        <div className={classes['paragraph']}>
            <p><a href='https://sessionloops.com/policies/terms-of-service'>Terms of Service</a></p>
        </div>
        

        </div>
  </Layout>
})

export default Google